import { Box, Button, makeStyles } from "@material-ui/core";
import { useAuthUser } from "Components/Auth/hooks/useAuthUser";
import { useCompany } from "Components/Company/hooks/useCompany";
import { useMemberRole } from "Components/Members/hooks/useMemberRole";
import { color, px } from "Configs/theme";
import { getColorRgbaFromHex } from "Helpers/ColorHelper";
import { useRedirect } from "Helpers/RedirectHelper";
import { useTranslation } from "Providers/TranslationProvider";
import { MemberRole } from "domain-entities";
import React, { FC } from "react";
import { dispatchEvent } from "../../../Helpers/AnalyticsHelper";
import { useApp } from "../../../Providers/AppProvider";
import { PlanningboardPaywallUpgradeSelectedEvent } from "../../../generated/events/PlanningboardEvents.generated";

interface Props {
	left?: number;
}

const MultiWeekDisabledView: FC<Props> = (props) => {
	const memberRole = useMemberRole();
	const userId = useAuthUser((state) => state.user?.uid);
	const companyId = useCompany((state) => state.item?.id);
	const { isNative } = useApp();

	const classes = useStyles({
		left: props.left,
	});

	const redirect = useRedirect();
	const { t } = useTranslation();

	function redirectToSubscription() {
		if (memberRole !== MemberRole.OWNER) return;
		if (!userId) return;
		if (!companyId) return;

		// This should be moved into a central location
		const version = require("../../../../package.json").version || "0.1.0";
		dispatchEvent(
			new PlanningboardPaywallUpgradeSelectedEvent({
				userId,
				companyId,
				version,
			})
		);

		redirect("settings/subscription", true);
	}

	return (
		<Box className={classes.outerBox}>
			<Box className={classes.innerBox}>
				{t("SubscriptionColumnView_Message")}
				{memberRole === MemberRole.OWNER && !isNative && (
					<Button
						color="primary"
						className={classes.ctaButton}
						onClick={(event) => {
							event.stopPropagation();
							redirectToSubscription();
						}}
					>
						{t("SubscriptionColumnView_Cta")}
					</Button>
				)}
			</Box>
		</Box>
	);
};

export default MultiWeekDisabledView;

interface StyleProps {
	left?: number;
}

const useStyles = makeStyles({
	outerBox: (props: StyleProps) => ({
		display: "flex",
		position: "absolute",
		backgroundColor: color.totalBackground,
		zIndex: 2,
		top: 0,
		left: props.left ?? 0,
		height: "100%",
		width: window.innerWidth,
	}),
	innerBox: {
		padding: `${px.s} ${px.m}`,
		backgroundColor: getColorRgbaFromHex(color.text, 0.05),
		display: "flex",
		alignItems: "center",
		flex: 1,
		fontSize: "12px",
		fontWeight: 500,
	},
	ctaButton: {
		marginLeft: px.xxs,
		fontSize: "12px",
	},
});
